import React from 'react';
import { RichText } from 'prismic-reactjs';
import { PrismicGrants } from '../../types/prismic';
import styles from './landing-header.module.scss';

interface Props {
  data: PrismicGrants;
}

const LandingHeader = ({ data }: Props) => {
  const { header_image, header, description } = data.data;

  return (
    <section className="full-height full-width no-overflow center">
      <div
        className={`inner-width inner-width-padding pb0 ${styles.container}`}
      >
        <div className={styles.content}>
          <article className={`${styles.copy}`}>
            {header && <h2 className={styles.header}>{header}</h2>}
            <RichText render={description} />
          </article>
          {header_image && (
            <img
              src={header_image.url}
              alt={header_image.alt}
              className={styles.banner}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default LandingHeader;
